export default __webpack_public_path__ + "static/media/folder.9954cf91.svg";